<template>
  <div class="CascadePicker temr">
    <van-field
      readonly
      clickable
      :label="params.title"
      v-model="text"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker = true"
    />
    <van-popup v-model="showTermPicker" position="bottom">
      <van-picker
        show-toolbar
        :key="params.initValue"
        :defaultIndex="firstIndex"
        :columns="columnsTerm"
        @cancel="showTermPicker = false"
        @confirm="onConfirm"
        title="职业大小类"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "CascadePicker",
  props: ["params", "placeholder", "columnsTerm"],

  data() {
    return {
      showTermPicker: false,
      text: "",
      firstIndex: 0,
      secondIndex: 0,
      // defaultIndex: 0,
    };
  },
  methods: {
    onConfirm(obj, index) {
      console.log(
        this.columnsTerm[index[0]].value,
        this.columnsTerm[index[0]].children[index[1]].value
      );
      this.$emit("input", `${this.columnsTerm[index[0]].value}-${this.columnsTerm[index[0]].children[index[1]].value}`);
      this.showTermPicker = false;
      this.text = obj[1];
    },
  },
  watch: {
    "params.initValue": {
      handler(val) {
        // val = '60000-69900';
        if (val) {
          let big = val.split('-')[0];
          let small = val.split('-')[1];
          this.firstIndex = this.columnsTerm.findIndex(
            (e) => e.value === big
          );
          this.secondIndex = this.columnsTerm[this.firstIndex].children.findIndex(
            (e) => e.value === small
          );
          this.columnsTerm[this.firstIndex].defaultIndex = this.secondIndex; // 以上设置picker默认值

          this.text = this.columnsTerm[this.firstIndex].children[this.secondIndex].text; // 此处设置回显文本
        }
      },
    },
  },
};
</script>
<style scoped>
.CascadePicker {
  position: relative;
}
>>> .van-ellipsis {
  font-size: 12px;
  white-space: pre-wrap;
}
>>> .van-field__label {
  text-align: left;
  color: #46494d;
  width: 86px;
  margin-right: 16px;
}
.van-picker__cancel,
.van-picker__confirm {
  color: #ff6538;
}
>>> .van-field__control::-webkit-input-placeholder {
  font-size: 16px;
  color: #bcc2cc;
}
>>> .van-field__control::-moz-input-placeholder {
  font-size: 16px;
  color: #bcc2cc;
}
>>> .van-field__control::-ms-input-placeholder {
  font-size: 16px;
  color: #bcc2cc;
}
>>> .van-cell::after {
  border-bottom: none !important;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
>>> .van-field__body {
  font-size: 16px;
}
>>> .van-picker-column__item {
  justify-content: flex-start;
  text-align: left;
}
</style>
